import { Box, Container, Grid, useMediaQuery, useTheme } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useState } from 'react'
import DesktopHeaderWrap from '../../components/DeskTopHeaderWrap'
import { useStyles } from './AddToCart.style'
import CartLeft from './compo/left/CartLeft'
// import { getBadgeCart } from '../../api/badge'
import { useAuth } from '../../hooks/useAuth'
import RestrictMobile from 'components/RestrictMobile'

const AddToCart = props => {
  const { token } = useAuth()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const datauser = JSON.parse(localStorage.getItem('userdata'))

  const { webThemeColor } = props
  const classes = useStyles()
  const [itemsCart, setItems] = useState(0)
  const [categoriesData, setCategoriesData] = useState([])
  const Usercode1 = JSON.parse(localStorage.getItem('usercode'))
  const mycartdata = async () => {
    if (token) {
      // const cartDataResult = await getBadgeCart()
      // if (cartDataResult.success) {
      //   setItems(cartDataResult.data)
      // }
    }
  }

  useEffect(() => {
    mycartdata()

    if (localStorage.getItem('landing_page')) {
      setCategoriesData(JSON.parse(localStorage.getItem('landing_page'))['product_categories'])
    }
  }, [Usercode1])

  useEffect(() => {
    // console.log("is_ useEffect");
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }, [])

  if (isMobile && datauser.role === 'requestor') {
    return <RestrictMobile />
  }

  return (
    <div className={classes.body}>
      <DesktopHeaderWrap
        // clickTab={() => setInlineCategory(false)}
        themeColor={'rgb(231, 0, 116)'}
        cartNumber={itemsCart}
        categoriesData={categoriesData}
      />
      <Container>
        <Box className={classes.root_addtocart}>
          <h5 className={classes.pageTitle}></h5>

          <Grid container>
            <Grid item md={12} xs={12}>
              <CartLeft webThemeColor={webThemeColor} />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  )
}

export default AddToCart
